var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-level flex-top activity-card" }, [
    _vm.oneLog.cardType === "object"
      ? _c(
          "div",
          { staticClass: "template-card-v2__object" },
          [_vm._t("icon")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "timelineCard",
        class: _vm.activityCardClass,
        on: {
          mouseenter: function($event) {
            return _vm.toggleActionBar(true)
          },
          mouseleave: function($event) {
            return _vm.toggleActionBar(false)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "card-body p-0 wp-10",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.emitClick($event)
              }
            }
          },
          [
            _c("div", { staticClass: "activity-card__container-badges" }, [
              _vm.oneLog.isPrivate
                ? _c(
                    "div",
                    {
                      staticClass:
                        "activity-card__container-badges__badge activity-card__container-badges__badge--private typographies-paragraph-small-semibold"
                    },
                    [
                      _c("CompassIcon", {
                        attrs: { size: "extra-small", icon: "lock-fill" }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$l10n.__("Privé")) +
                          "\n                "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.oneLog.pin
                ? _c(
                    "div",
                    {
                      staticClass:
                        "activity-card__container-badges__badge activity-card__container-badges__badge--pinned typographies-paragraph-small-semibold"
                    },
                    [
                      _c("CompassIcon", {
                        attrs: { size: "extra-small", icon: "pin-fill" }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$l10n.__("Épinglé")) +
                          "\n                    "
                      ),
                      _vm.registeredUserPin.length > 0
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "activity-card__container-badges__badge--pinned activity-card__container-badges__badge__username"
                            },
                            [
                              _vm._v(
                                "\n                        (" +
                                  _vm._s(_vm.registeredUserPin) +
                                  ")\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-column ov-hidden" }, [
              _c(
                "div",
                { staticClass: "activity-card-header__container" },
                [
                  _vm._t("label"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "activity-card-header-action__container flex-item-right ovy-reset flex-row ai-center gray-60 fs-2"
                    },
                    [
                      !_vm.oneLog.allDay
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "nowrap activity-card-header-date__container mr-2"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      _vm.oneLog.timestamp,
                                      "NORMAL_DATE_TIME",
                                      true
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass:
                                "nowrap activity-card-header-date__container mr-2"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      _vm.oneLog.timestamp,
                                      "NORMAL_DATE",
                                      true
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c(_vm.actionBarComponent, {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isActionBarVisible,
                            expression: "isActionBarVisible"
                          }
                        ],
                        ref: "timelineActionBar",
                        tag: "component",
                        attrs: {
                          oneLog: _vm.oneLog,
                          linkedid: _vm.linkedid,
                          linkedtype: _vm.linkedtype,
                          isDocument: _vm.isDocument,
                          overviewType: _vm.overviewType,
                          subtype: _vm.getCardType,
                          isActionBarVisible: _vm.isActionBarVisible,
                          isPinned: _vm.isPinned,
                          pinStatusLabel: _vm.pinStatusLabel,
                          displayHistory: _vm.displayHistory
                        },
                        on: {
                          toggleHistory: _vm.toggleHistory,
                          "toggle-pin": _vm.pin
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c("div", [_vm._t("content")], 2)
            ]),
            _vm._v(" "),
            _vm._t("linked", [
              _vm.showLinked
                ? _c(
                    "div",
                    { staticClass: "activity-card-attachment__container" },
                    [
                      _vm.oneLog.contacts && _vm.oneLog.contacts.list
                        ? _vm._l(_vm.oneLog.contacts.list, function(contact) {
                            return _c("TemplateCardAttachment", {
                              key: contact.type + "-" + contact.id,
                              attrs: { item: contact }
                            })
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.oneLog.linkeds && _vm.oneLog.linkeds.length > 0
                        ? _vm._l(_vm.oneLog.linkeds, function(linked) {
                            return _c("TemplateCardAttachment", {
                              key: linked.type + "-" + linked.id,
                              attrs: { item: linked }
                            })
                          })
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._t("footer", [
              _vm.history
                ? _c(
                    "div",
                    { class: { "mt-3": _vm.displayHistory } },
                    [
                      _c("HistoryCardLog", {
                        attrs: {
                          histories: _vm.history,
                          displayHistory: _vm.displayHistory,
                          loading: _vm.historyLoading,
                          linkedid: _vm.linkedid,
                          linkedtype: _vm.linkedtype
                        },
                        on: { "close-history": _vm.toggleHistory }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }